export default __webpack_public_path__ + "static/media/boost_ig.e682c0fa.png";